module.exports = __webpack_public_path__ + "static/media/ana-furniture-large_2x.363ef2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/ana-furniture-large_2x.png
// module id = 804
// module chunks = 27